import { render, staticRenderFns } from "./MMP_DLL.vue?vue&type=template&id=2c970b1a&scoped=true&"
import script from "./MMP_DLL.vue?vue&type=script&lang=js&"
export * from "./MMP_DLL.vue?vue&type=script&lang=js&"
import style0 from "./MMP_DLL.vue?vue&type=style&index=0&id=2c970b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c970b1a",
  null
  
)

export default component.exports